import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, IdDescription, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { OrderType } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class OrderTypeService extends TmsWebBaseEditService<OrderType, OrderType> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('OrderType', $localize`Order Type`, httpService, notificationService);
  }

  getForType(type: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForType?type=${type}`);
  }
}
